<template>
  <div class="gift-card">
      <van-image
        v-if="loading"
        class="card-img"
      />
      <img v-else class="card-img" :src="createOrderParams.orderUrlImage">
    <div class="card-list fx" v-if="pageData.cardFaceList && pageData.cardFaceList.length > 1">
      <div class="item fx fx-column fx-center" @click="onCardTap(index, item.cardFaceUrlImage, item.cardFaceRemarks)" v-for="(item, index) in pageData.cardFaceList" :key="item.cardFaceId">
        <van-image :class="{'active': current === index}" :src="item.cardFaceUrlImage" :width="100" />
        <van-icon name="checked" size="18" v-show="current === index" />
      </div>
    </div>
    <div class="goods">
      <div class="bold">Select Product</div>
      <!-- 商品列表骨架屏 -->
      <div class="goods-list" v-if="loading">
        <div class="item fx">
          <van-image class="goods-pic" :width="80" :height="80" />
          <div class="info fx fx-between">
            <div class="fx fx-column fx-between">
              <p class="name bold">--</p>
              <p class="price-box">
                <span>--</span>
              </p>
            </div>
            <div class="fx fx-column fx-end disabled">
              <div class="stepper fx fx-items-center">
                <button class="van-stepper__minus"></button>
                <span class="num">0</span>
                <button class="van-stepper__plus"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 商品列表 -->
      <div class="goods-list" v-else>
        <div class="item fx" v-for="(item, index) in pageData.goodsList" :key="item.goodsId">
          <div class="fx fx-column fx-center" style="width: 80px; height: 80px;margin-right: 10px">
            <van-image class="goods-pic" :src="item.goodsUrlIco" @click="checkGoods(item)" />
          </div>
          <div class="info fx fx-column fx-between" style="flex: 1; min-width: 0;">
            <p class="name bold" style="word-wrap: break-word;">{{item.goodsName}}</p>
            <div class="fx fx-between">
              <div class="fx fx-column fx-between" @click="checkGoods(item)">
                <p class="price-box" v-if="item.currency">
                  <span>{{item.currency | unitFormat}}{{item.priceReal | numFormat(2)}}&nbsp;</span>
                  <span class="gray line-through" v-if="item.priceReal != item.priceSale">{{item.currency | unitFormat}}{{item.priceSale | numFormat(2)}}</span>
                </p>
              </div>
              <div class="fx fx-column fx-end">
                <div class="stepper fx fx-items-center">
                  <button class="van-stepper__minus" v-if="item.goodsNum > 0" @click="onMinusTap(item.goodsId, index)"></button>
                  <span class="num" v-if="item.goodsNum > 0">{{item.goodsNum}}</span>
                  <button class="van-stepper__plus" @click="onPlusTap(item.goodsId, index)"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buy fx fx-between">
      <div class="total">
        <p class="num gray">Total {{cartNum}} {{cartNum > 1 ? 'Products' : 'Product'}}</p>
        <p v-if="pageData.goodsList && pageData.goodsList.length > 0">
          <span class="bold">{{pageData.goodsList[0].currency | unitFormat}}{{cartTotalAmount | numFormat(2)}}</span>
          <span class="gray line-through" v-if="cartDiscountAmount != 0">{{pageData.goodsList[0].currency | unitFormat}}{{cartDiscountAmount}}</span>
        </p>
      </div>
      <van-button type="info" round @click="onBuyTap" :disabled="cartNum === 0">Place Order</van-button>
    </div>
    <van-dialog v-model="showDialog">
      <div class="dialog">
        <van-image :src="detailsData.goodsUrlIco ? detailsData.goodsUrlIco : 'https://ebuyimg.e-mallchina.com/olvp/autogoods.png'"/>
        <p v-html="detailsData.description"></p>
        <p v-html="detailsData.instructions"></p>
      </div>
    </van-dialog>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/lodash@4.13.1/lodash.min.js"></script>
<script>
  import _ from 'lodash'
  export default {
    data() {
      return {
        loading: true,
        showDialog: false,
        current: 0,
        popupData: {
          isShow: false,
          text: 'System is busy, please try again later.',
          btn: 'OK'
        },
        pageData: {},
        advertListParams: {
          token: '',
          listId: '',
          listType: ''
        },
        addCartParams: {
          clearCart: 'Yes',
          token: '',
          goodsList: [{
            goodsId: '',
            goodsNum: 0,
            checkStatus: 'Checked'
          }]
        },
        createOrderParams: {
          token: '',
          orderUrlImage: '',
          orderRemarks: '',
          memberId: '',
          goodsList: []
        },
        defaultInit: true,
        fbId: null,
        cartTotalAmount: 0,
        cartDiscountAmount: 0,
        cartData: [],
        detailsData: {},
        cartNum: 0
      }
    },
    created() {
      const queryParams = this.$route.query
      const token = this.$util.storageGet('local', 'token') || ''
      this.advertListParams.token = token
      this.addCartParams.token = token
      this.createOrderParams.token = token

      this.advertListParams.listId = queryParams.id
      this.advertListParams.listType = queryParams.type
      this.loadData()
    },
    methods: {
      // 获取当前卡面下所有商品信息
      getAdvertListData(params) {
        return this.$http.post('/olvp/getAdvertListData', 'getAdvertListData', params, false, false)
      },
      // 添加购物车 （修改购买数量）
      addCartGoods(params) {
        return this.$http.post('/olvp/addCartGoods', 'addCartGoods', params, false, false)
      },
      // 创建订单
      createOrder(params) {
        return this.$http.post('/olvp/createOrder', 'createOrder', params, true, false)
      },
      // 页面数据加载
      loadData() {
        this.getAdvertListData(this.advertListParams).then((d) => {
          if (d.success) {
            if (d.content.goodsList[0].marketId != this.$util.storageGet('local', 'marketId')) {
              this.$router.replace('/home')
            }
            this.pageData = d.content
            this.createOrderParams.orderUrlImage = this.pageData.cardFaceList[0].cardFaceUrlImage
            this.createOrderParams.orderRemarks = this.pageData.cardFaceList[0].cardFaceRemarks
            this.pageData.goodsList.map((v) => {
              v.goodsNum = 0
            })
            this.loading = false
          }
        })
      },
      onCardTap(i, img, remarks) {
        this.current = i
        this.createOrderParams.orderUrlImage = img
        this.createOrderParams.orderRemarks = remarks
      },
      checkGoods (item) {
        this.detailsData = item
        this.showDialog = true
      },
      // 减号
      onMinusTap: _.debounce(
        function (goodsId, index) {
          if (this.pageData.goodsList[index].goodsNum === 0) {
            return false
          }
          let goodsNum = this.pageData.goodsList[index].goodsNum - 1
          this.addCartParams.goodsList[0].goodsId = goodsId
          this.addCartParams.goodsList[0].goodsNum = goodsNum
          this.addCartGoods(this.addCartParams).then((d) => {
            if (d.success) {
              this.pageData.goodsList[index].goodsNum = goodsNum
              this.$set(this.pageData.goodsList, index, this.pageData.goodsList[index]) // 更新数组重新绑定渲染
              this.cartData = d.content.goodsList
              this.cartTotalAmount = d.content.cartTotalAmount
              this.cartDiscountAmount = d.content.cartDiscountAmount
              this.createOrderParams.goodsList = d.content.goodsList
              this.cartNum = 0
              this.cartData.map((v) => {
                this.cartNum += v.goodsNum
              })
            }
          })
        },
        500
      ),
      // 加号
      onPlusTap: _.debounce(
        function (goodsId, index) {
          const token = this.$util.storageGet('local', 'token') || ''
          if (!token) {
            this.$cux.confirm({
              message: 'Please login to proceed.',
              confirmButtonText: 'Sign-up/Login',
              cancelButtonText: 'Cancel'
            }).then(() => {
              this.$router.push(`/login?backPath=${encodeURIComponent(this.$route.fullPath)}`)
            })
          } else {
            let goodsNum = this.pageData.goodsList[index].goodsNum + 1
            this.addCartParams.goodsList[0].goodsId = goodsId
            this.addCartParams.goodsList[0].goodsNum = goodsNum
            // 首次进入 清空购物车 defaultInit===true
            this.addCartParams.clearCart = this.defaultInit ? 'Yes' : 'No'
            this.addCartGoods(this.addCartParams).then((d) => {
              if (d.success) {
                this.pageData.goodsList[index].goodsNum = goodsNum
                this.$set(this.pageData.goodsList, index, this.pageData.goodsList[index]) // 更新数组重新绑定渲染
                this.defaultInit = false // 首次添加购物车
                this.cartData = d.content.goodsList
                this.cartTotalAmount = d.content.cartTotalAmount
                this.cartDiscountAmount = d.content.cartDiscountAmount
                this.createOrderParams.memberId = d.content.goodsList[0].memberId
                this.createOrderParams.goodsList = d.content.goodsList
                this.cartNum = 0
                this.cartData.map((v) => {
                  this.cartNum += v.goodsNum
                })
              }
            })
          }
        },
        500
      ),
      onBuyTap: _.debounce(
        function () {
          this.$util.storageDel('session', 'giftImg')
          this.$util.storageDel('session', 'giftDesc')
          this.createOrderParams.goodsList.map((v) => {
            v.checkStatus = 'Checked'
          })
          this.createOrder(this.createOrderParams).then((d) => {
            if (d.success) {
              this.$router.push(
                `/orderDetail?type=${'pay'}&orderId=${d.content.orderId}`
              )
            }
          })
        },
        500
      )
    }
  }
</script>

<style lang="scss">
  .gift-card {
    width: 100%;
    height: 100%;
    padding: 30px 0 20px 0;
    .card-img {
      width: 75%;
      border-radius: 8px;
      overflow: hidden;
      display: block;
      margin: 0 auto;
      border-radius: 8px;
      box-shadow: 0px 0px 15px #dbdbdb;
    }

    .dialog {
      height: 60vh;
      padding: 15px;
      overflow-y: scroll;
      p {
        margin-top: 15px;
        word-wrap: break-word;
      }
    }
    .current {
      width: 70%;
      margin: 0 auto;
      box-shadow: 5px 5px 10px #dbdbdb;
      border-radius: 8px;
    }

    .card-list {
      width: 100%;
      overflow: scroll;
      padding: 12px;
      margin-top: 30px;
      background: #f5f5f5;
      box-sizing: border-box;
      .item {
        background: #fff;
        color: #1989fa;
        margin-right: 15px;
        position: relative;
        .van-image {
          border: 2px solid #f5f5f5;
          border-radius: 5px;
          overflow: hidden;
          &.active {
            border: 2px solid #1989fa;
          }
        }
        .van-icon {
          position: absolute;
          right: -9px;
          top: -9px;
          border-radius: 50%;
          background: #fff;
        }
      }
    }
    .goods {
      padding: 12px;
      margin-top: 20px;
      .goods-list {
        margin-top: 15px;
        padding-bottom: 60px;
        .item {
          margin-bottom: 15px;
          .goods-pic {
            width: 80px;
          }
        }
        .disabled {
          color: #969799;
          button {
            background: #F7F8FA;
            border-color: #F7F8FA;
            color: #969799;
          }
        }
      }
    }

    .buy {
      width: 100%;
      max-width: 480px;
      margin: 0 auto;
      font-size: 12px;
      padding: 12px;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      z-index: 99;
      .van-button {
        width: 35%;
      }
      .total {
        .red {
          font-size: 15px;
          margin-right: 10px;
        }
        .num {
          margin-bottom: 10px;
        }
        .bold {
          font-size: 16px;
        }
      }
    }

    .pupup-content {
      text-align: center;
      font-size: 19px;
      line-height: 25px;

      .van-button {
        margin-top: 20px;
        width: 120px;
      }
    }

    .stepper {
      button {
        border-radius: 50%;
        border: 1px solid #1989fa;
      }

      .van-stepper__plus {
        color: #fff;
        background: #1989fa;
      }

      .van-stepper__minus {
        color: #1989fa;
        background: transparent;
      }

      .num {
        margin: 0 8px;
        font-size: 16px;
      }
    }
  }
</style>
